/** @format */

import { DCSG_CONSTANTS } from '@shared/data-access/constants';

export interface CeopsScript {
  active: boolean;
  chains: string[];
  path: string;
  placements?: string[];
  exclusions?: string[];
  loadSynchronously?: boolean;
  src?: string;
  ecommScript?: boolean;
}

export interface CeopsResponse {
  data_source: string;
  scripts: CeopsScript[];
  source: string;
  version: string;
}

export enum ScriptTypes {
  MODULE = 'module',
  CLASSIC = 'text/javascript',
}

export enum LinkRelTypes {
  MODULE = 'modulepreload',
  CLASSIC = 'preload',
}

/** Server: bounded tight — this call blocks SSR serialization on every PDP request. */
export const CEOPS_SERVER_TIMEOUT_MS = DCSG_CONSTANTS.timeouts.xxshort; // 2000
/** Client: post-hydration, non-blocking. */
export const CEOPS_CLIENT_TIMEOUT_MS = DCSG_CONSTANTS.timeouts.short; // 10000
// 0: retry(timeoutMs) resubscribes and restarts the timer, so any retries here would multiply the SSR block
export const CEOPS_SERVER_RETRIES = 0;
export const CEOPS_CLIENT_RETRIES = 3;
/** Floor for a misconfigured (e.g. `0`) environment timeout value; `timeout(0)` fires synchronously. */
export const CEOPS_MIN_TIMEOUT_MS = 250;
